const tab_sections = {
    overview: '살펴보기',
    resource_management: 'Resource 관리',
    user_management: '사용자 관리',
    help_and_support: '고객센터',
};
export default tab_sections;
